import React from 'react';
import styled from 'styled-components';
import { ButtonLink } from '../../../components/Button';
import {
  CallToAction,
  CallToActionButton
} from '../../../components/CallToAction';
import { TypoImage } from '../../../components/TypoImage';
import { CType } from '../../../provider/Typo3Provider/types';

const StyledTypoImage = styled(TypoImage)`
  min-height: 280px;
`;

const CallToActionContainer = (props: CType) => {
  const { header, header_link, files = { image: [] } } = props;
  const [image = null] = files.image || [];

  return (
    <CallToAction>
      {image && <StyledTypoImage image={image} />}
      {header && header_link && (
        <CallToActionButton>
          <ButtonLink large to={header_link} outlined>
            {header}
          </ButtonLink>
        </CallToActionButton>
      )}
    </CallToAction>
  );
};

export default CallToActionContainer;
